import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { Button } from '@ipc/ipc-components';
import CheckboxTreeSelector from '../../../common/selection-criteria/operator-impc/CheckboxTreeSelector';
import { getAssetType } from '../../../common/asset-types/redux/selectors/AssetTypesSelectors';
import {
  getLeftCheckedMailProcessingCenters,
  getLeftPostalOperators,
} from '../../../common/user/redux/selectors/UserDataSelectors';
import {
  onLeftMailProcessingCenterChecked,
  onSelectAllLeftMailProcessingCenters,
  onUnselectAllLeftMailProcessingCenters,
  retrieveAllLeftOperatorsWithImpcsRequestActionCreator,
} from '../../../common/selection-criteria/operator-impc/redux/actions/OperatorImpcActions';
import { poolMembershipManagementSaveRequestActionCreator } from '../redux/actions/PoolMembershipManagementActions';

class PoolMembershipManagementContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      expanded: [],
    };
  }

  componentDidMount() {
    this.props.retrieveAllLeftOperatorsWithImpcsRequestActionCreator({
      assetType: this.props.appContext.appContext,
      useGlobalPresets: true,
    });
  }

  getAppContextString = () => {
    switch (this.props.appContext.appContext) {
      case 'tray':
        return 'Tray';
      case 'bag':
        return 'Bag';
      case 'pallet':
        return 'Pallet Box';
      default:
        return 'Tray';
    }
  }

  onCheck = (checked) => {
    this.props.onLeftMailProcessingCenterChecked(checked);
  };

  onSelectAll = () => {
    this.props.onSelectAllLeftMailProcessingCenters(this.props.postalOperatorNodes);
  };

  onDeselectAll = () => {
    this.props.onUnselectAllLeftMailProcessingCenters();
  };

  onExpand = (expanded) => {
    this.setState({
      expanded,
    });
  };

  onSave = () => {
    this.props.poolMembershipManagementSaveRequestActionCreator(this.props.appContext.appContext, this.props.checkedMailProcessingCenters);
  }

  render() {
    return (
      <div className="general-content-container">
        <h1 className="title-div">POOL MEMBERSHIP MANAGEMENT</h1>
        <table className="form-table">
          <tbody>
            <tr>
              <td height={720} width={1700}>
                <CheckboxTreeSelector
                  title={`${this.getAppContextString()} Pool`}
                  nodes={this.props.postalOperatorNodes}
                  checked={this.props.checkedMailProcessingCenters}
                  onCheck={this.onCheck}
                  expanded={this.state.expanded}
                  onExpand={this.onExpand}
                  onSelectAll={this.onSelectAll}
                  onDeSelectAll={this.onDeselectAll}
                />
              </td>
              <td>
                <Button
                  className="primary-button-false"
                  onClick={this.onSave}
                >
                  Save Selection
                </Button>
              </td>
            </tr>

          </tbody>
        </table>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    appContext: getAssetType(state),
    postalOperatorNodes: getLeftPostalOperators(state),
    checkedMailProcessingCenters: getLeftCheckedMailProcessingCenters(state),
  };
}

const mapDispatchToProps = (dispatch) => bindActionCreators({
  retrieveAllLeftOperatorsWithImpcsRequestActionCreator,
  poolMembershipManagementSaveRequestActionCreator,
  onLeftMailProcessingCenterChecked,
  onSelectAllLeftMailProcessingCenters,
  onUnselectAllLeftMailProcessingCenters,
}, dispatch);

PoolMembershipManagementContainer.propTypes = {
  appContext: PropTypes.objectOf(PropTypes.string),
  postalOperatorNodes: PropTypes.arrayOf(PropTypes.object),
  checkedMailProcessingCenters: PropTypes.arrayOf(PropTypes.string),
  onLeftMailProcessingCenterChecked: PropTypes.func,
  onSelectAllLeftMailProcessingCenters: PropTypes.func,
  onUnselectAllLeftMailProcessingCenters: PropTypes.func,
  retrieveAllLeftOperatorsWithImpcsRequestActionCreator: PropTypes.func,
  poolMembershipManagementSaveRequestActionCreator: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(PoolMembershipManagementContainer);
